import { Alert, Chip } from '@mui/material';
import { DISCLAMER_TEXT } from '@k-ucap/shared';

export const Disclaimer = () => (
  <Alert severity="info" sx={{ mt: 2 }}>
    {DISCLAMER_TEXT}
  </Alert>
);

export const DisclaimerChip = () => <Chip label="PoC Only" size="small" color="warning" />;
